import generateAnnualPaymentUrl from './generate-annual-payment-url';
import generatePaymentUrl from './generate-payment-url';

export default {
  generateAnnualPaymentUrl,
  generatePaymentUrl,
};
